import React, { useState } from "react";
import "./filters.scss";

const Filters = (props) => {
  const {
    restaurants,
    favorites,
    setRestaurants,
    toggleRating,
    setToggleRating,
    toggleDeliveryTime,
    setToggleDeliveryTime,
    toggleFavorite,
    setToggleFavorite,
    searchTerm,
    setSearchTerm,
  } = props;
  const [selectCategory, setSelectCategory] = useState("");
  const [isToggled, setIsToggled] = useState(false);
  const token = localStorage.getItem("token");
  const handleSelectCategoryChange = (event) => {
    setSelectCategory(event.target.value);
  };

  const handleToggleOn = () => {
    setIsToggled(true);
  };
  const handleToggleOff = () => {
    setIsToggled(false);
  };

  const filterByDeliveryTime = () => {
    console.log("filter by delivery time");

    if (!toggleDeliveryTime) {
      const restaurantsFilteredBydeliveryTime = restaurants.sort((a, b) => {
        // Sort by restaurant_review in descending order
        return a.distance - b.distance;
      });
      setRestaurants(restaurantsFilteredBydeliveryTime);
      setToggleDeliveryTime(!toggleDeliveryTime);
    } else {
      setRestaurants(JSON.parse(sessionStorage.getItem("restaurants")));
      setToggleDeliveryTime(!toggleDeliveryTime);
    }
  };
  const handleSelectRatingChange = () => {
    console.log("filter by rating");

    if (!toggleRating) {
      const restaurantsFilteredByRating = restaurants.sort((a, b) => {
        // Sort by restaurant_review in descending order
        return b.restaurant_review - a.restaurant_review;
      });
      console.log(restaurantsFilteredByRating);
      setRestaurants(restaurantsFilteredByRating);
      setToggleRating(!toggleRating);
    } else {
      setRestaurants(JSON.parse(sessionStorage.getItem("restaurants")));
      setToggleRating(!toggleRating);
    }
  };
  const filterByCategory = async () => {
    if (selectCategory !== "All Categories") {
      const restaurantsCopy = JSON.parse(sessionStorage.getItem("restaurants"));
      const filteredByCategory = await restaurantsCopy.filter((restaurant) => {
        const categoryMatch =
          selectCategory === "" ||
          restaurant.restaurant_category === selectCategory;
        console.log(categoryMatch);

        return categoryMatch;
      });
      setRestaurants(filteredByCategory);
      // setToggleDeliveryTime(!toggleDeliveryTime);
    } else {
      setRestaurants(JSON.parse(sessionStorage.getItem("restaurants")));
      // setToggleDeliveryTime(!toggleDeliveryTime);
    }

    // console.log(filteredAndSortedRestaurants);
  };
  const filterByFavorite = () => {
    if (!toggleFavorite) {
      setRestaurants(favorites);
      setToggleFavorite(!toggleFavorite);
    } else {
      setRestaurants(JSON.parse(sessionStorage.getItem("restaurants")));
      setToggleFavorite(!toggleFavorite);
    }
  };
  const handleSearch = () => {
    if (searchTerm === "") {
      setRestaurants(JSON.parse(sessionStorage.getItem("restaurants")));
    } else {
      const filteredRestaurants = restaurants.filter((restaurant) =>
        restaurant.restaurant_name
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
      setRestaurants(filteredRestaurants);
    }
  };

  return (
    <div className="filter-container">
      <div className="ToggleButton-container">
        <button
          id="Delivery-button"
          style={{
            backgroundColor: isToggled ? "#007664" : "#cccccc",
            color: isToggled ? "white" : "black",
          }}
          onClick={handleToggleOn}
        >
          Delivery
        </button>
        <button
          id="Pickup-button"
          style={{
            backgroundColor: !isToggled ? "#007664" : "#cccccc",
            color: !isToggled ? "white" : "black",
          }}
          onClick={handleToggleOff}
        >
          Pickup
        </button>
      </div>

      <div className="ToggleSwitchButton-container">
        {/* <div className="Open-Now">
          <h1>Open now</h1>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div> */}
        <div className="Open-Now">
          <h1>By rating</h1>
          <label className="switch">
            <input onClick={handleSelectRatingChange} type="checkbox" />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="Delivery-time">
          <h1>Delivery time</h1>
          <label className="switch">
            <input type="checkbox" />
            <span
              className="slider round"
              onClick={filterByDeliveryTime}
            ></span>
          </label>
        </div>
        {token && (
          <div className="by-favorite">
            <h1>My favorite restaurants</h1>
            <label className="switch">
              <input onClick={filterByFavorite} type="checkbox" />
              <span className="slider round"></span>
            </label>
          </div>
        )}
      </div>

      <select
        id="restaurantSelector"
        value={selectCategory}
        onChange={handleSelectCategoryChange}
        onClick={filterByCategory}
      >
        <option value="All Categories">All Categories</option>
        <option value="Boulangerie/Patisserie">Boulangerie/Patisserie</option>
        <option value="Brasserie">Brasserie</option>
        <option value="Café">Café</option>
        <option value="Crêperie">Crêperie</option>
        <option value="Bistro">Bistro</option>
        <option value="Fromagerie">Fromagerie</option>
        <option value="Poissonnerie">Poissonnerie</option>
        <option value="Charcuterie">Charcuterie</option>
        <option value="Gastronomic Restaurant">Gastronomic Restaurant</option>
        <option value="Wine Bar">Wine Bar</option>
        <option value="French-Italian Trattoria">
          French-Italian Trattoria
        </option>
        <option value="Vegetarian/Vegan">Vegetarian/Vegan</option>
      </select>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by restaurant name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>
    </div>
  );
};

export default Filters;
